'use client'

import { PropsWithChildren } from 'react'
import { HotkeysProvider } from 'react-hotkeys-hook'

export default function Provider(props: PropsWithChildren) {
  return <HotkeysProvider initiallyActiveScopes={['settings']}>{props.children}</HotkeysProvider>
}
